import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";

export async function ToggleVisibilityCategoriaProductoAction(
  idCategoria: string
): Promise<ApiResponse<CategoriasProductoInterface>> {
  const { data } = await apiClient.patch<CategoriasProductoInterface>(
    `gpCategoriasProducto/${idCategoria}/toggleVisibility`
  );
  return {
    status: 200,
    data,
    message:
      "Visibilidad de la categoría de producto actualizada correctamente",
  };
}
